// extracted by css-extract-rspack-plugin
export default {"subtext":"SetupComplete_subtext__-sIVS"};